import { EmbeddedMessage, WhatsApp } from 'constants/messageMediums';
import { CampaignType, CampaignTypeFilter, MessageMedium } from 'modules/domains/campaign';
import { FC } from 'react';
import {
  EligibilityCampaign,
  SendMultiChannel,
  SvgIconProps,
  TriggerWorkflow,
  EmailLine24,
  SmsLine24,
  InAppLine24,
  PushLine24,
  WebPushLine24,
  EmbeddedLine24,
  WhatsAppLine24,
} from 'ui/icons';

export type ContentMapperItem = {
  Icon: FC<React.PropsWithChildren<SvgIconProps>>;
  displayName: string;
};

export const generateMediumContentItem = (
  Icon: ContentMapperItem['Icon'],
  displayName: ContentMapperItem['displayName'],
) => ({
  Icon,
  displayName,
});

export const MESSAGE_MEDIUM_CONTENT_MAPPER: { [key in MessageMedium]: ContentMapperItem } = {
  [MessageMedium.Email]: generateMediumContentItem(EmailLine24, 'Email'),
  [MessageMedium.SMS]: generateMediumContentItem(SmsLine24, 'SMS'),
  [MessageMedium.InApp]: generateMediumContentItem(InAppLine24, 'In-App'),
  [MessageMedium.Push]: generateMediumContentItem(PushLine24, 'Push'),
  [MessageMedium.WebPush]: generateMediumContentItem(WebPushLine24, 'Web Push'),
  [EmbeddedMessage]: generateMediumContentItem(EmbeddedLine24, 'Embedded'),
  [WhatsApp]: generateMediumContentItem(WhatsAppLine24, 'WhatsApp'),
};

export const CAMPAIGN_TYPE_CONTENT_MAPPER: { [key in CampaignType]: ContentMapperItem } = {
  [CampaignType.Blast]: generateMediumContentItem(SendMultiChannel, 'Blast'),
  [CampaignType.ApiTriggered]: generateMediumContentItem(TriggerWorkflow, 'Triggered'),
  [CampaignType.Eligibility]: generateMediumContentItem(EligibilityCampaign, 'Eligibility'),
  [CampaignType.WorkflowTriggered]: generateMediumContentItem(TriggerWorkflow, 'Triggered'),
  [CampaignType.WithExperiment]: generateMediumContentItem(TriggerWorkflow, 'Triggered'),
  [CampaignType.WithAI]: generateMediumContentItem(TriggerWorkflow, 'Triggered'),
};

export const CAMPAIGN_TYPE_FILTER_CONTENT_MAPPER: {
  [key in CampaignTypeFilter]: ContentMapperItem;
} = {
  [CampaignTypeFilter.Blast]: generateMediumContentItem(SendMultiChannel, 'Blast'),
  [CampaignTypeFilter.Triggered]: generateMediumContentItem(TriggerWorkflow, 'Triggered'),
  [CampaignTypeFilter.Eligibility]: generateMediumContentItem(EligibilityCampaign, 'Eligibility'),
  [CampaignTypeFilter.FromWorkflow]: generateMediumContentItem(TriggerWorkflow, 'Triggered'),
  [CampaignTypeFilter.WithExperiment]: generateMediumContentItem(TriggerWorkflow, 'Triggered'),
  [CampaignTypeFilter.WithAI]: generateMediumContentItem(TriggerWorkflow, 'Triggered'),
};
